import { Overlay } from "@radix-ui/react-alert-dialog";

import React from "react";

import { cn } from "@/lib/utils";

type AlertOverlayProps = {
  className?: string;
};

const AlertOverlay = React.forwardRef<HTMLDivElement, AlertOverlayProps>(
  (props, forwardedRef) => {
    const { className, ...rest } = props;
    return (
      <Overlay
        {...rest}
        ref={forwardedRef}
        className={cn("z-50 bg-black bg-opacity-70 fixed inset-0", className)}
      />
    );
  },
);
AlertOverlay.displayName = "AlertOverlay";

export { AlertOverlay };
